import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';
import { VisitEnterButton } from '~libs.desktop.shared.visit-enter';

import { useVisitDependenciesContext } from '../../../../../dependencies';
import { appointmentsTranslationKeys, calendarTranslationKeys } from '../../../../../translations';

type AppointmentVisitContinueVisitButtonProps = {
   readonly appointmentId: number;
   readonly visitId: Visit['id'];
   readonly disabled: boolean;
   readonly patientId: number;
};

export const AppointmentVisitContinueVisitButton = (props: AppointmentVisitContinueVisitButtonProps): JSX.Element => {
   const { accountConfigurationVerificationEventInterceptor } = useVisitDependenciesContext();
   const push = useHistoryPushWithBackAction(true);

   const handleCompleteVisit = (): void => {
      push(
         visitPaths.getVisitInterviewPath({
            params: {
               visitId: props.visitId,
            },
         }),
         {}
      );
   };

   return (
      <VisitEnterButton
         compact
         appointmentId={props.appointmentId}
         patientId={props.patientId}
         label={appointmentsTranslationKeys.finish}
         onClick={handleCompleteVisit}
         disabled={props.disabled}
         variant={ButtonVariant.PRIMARY}
         accountConfigurationVerificationEventInterceptor={accountConfigurationVerificationEventInterceptor}
         testId={'enterVisit'}
         goBackButtonLabel={calendarTranslationKeys.goBackToCalendar}
      />
   );
};
